import { jsx } from "react/jsx-runtime";
import { Stack } from "../Stack/Stack.mjs";
function SelectFieldInternalList({ dividers, children }) {
  return /* @__PURE__ */ jsx(Stack, { space: "none", component: "ul", dividers, children });
}
export {
  SelectFieldInternalList
};
